module.exports = __webpack_public_path__ + "img/person-bounding-box.c9f3540c.svg";